/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
// @ts-ignore
import type * as Types from '../../../../../packages/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type ContractInput = {
  isTrustedSupplier: boolean;
};

export type UpdateContractInput = {
  companyId: string;
  contractId: string;
  contractInput?: ContractInput | null | undefined;
};

export type UpdateContractByBuyerMutationVariables = Exact<{
  data: Types.UpdateContractInput;
}>;


export type UpdateContractByBuyerMutation = { updateContract: { contractId: string } | null };


export const UpdateContractByBuyerDocument = /*#__PURE__*/ gql`
    mutation UpdateContractByBuyer($data: updateContractInput!) {
  updateContract(data: $data) {
    contractId
  }
}
    `;
export type UpdateContractByBuyerMutationFn = Apollo.MutationFunction<UpdateContractByBuyerMutation, UpdateContractByBuyerMutationVariables>;

/**
 * __useUpdateContractByBuyerMutation__
 *
 * To run a mutation, you first call `useUpdateContractByBuyerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContractByBuyerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContractByBuyerMutation, { data, loading, error }] = useUpdateContractByBuyerMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateContractByBuyerMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContractByBuyerMutation, UpdateContractByBuyerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContractByBuyerMutation, UpdateContractByBuyerMutationVariables>(UpdateContractByBuyerDocument, options);
      }
export type UpdateContractByBuyerMutationHookResult = ReturnType<typeof useUpdateContractByBuyerMutation>;
export type UpdateContractByBuyerMutationResult = Apollo.MutationResult<UpdateContractByBuyerMutation>;
export type UpdateContractByBuyerMutationOptions = Apollo.BaseMutationOptions<UpdateContractByBuyerMutation, UpdateContractByBuyerMutationVariables>;